import React from 'react'
import { Skeleton } from '../Skeleton';
export default function MasterDoctorLoader() {
  return (
    <div className="w-100 text-start rounded connectCard d-flex align-items-center justify-content-between cursorPointer bg-white shadow position-relative py-3 ps-3 pe-5 mb-3">
      <div className="rounded-circle connectCardPic position-relative overflow-hidden">
        <Skeleton variant="circular" width={'100%'} height={'100%'} />
      </div>
      <div className="connectCardContent ps-3 pe-2">
        <h3 className="text-black fs-16 fw-medium">
          <Skeleton variant="text" width={'90%'} height={25} />
        </h3>
        <h5 className="text-black fs-5 mb-1">
          <Skeleton variant="text" width={'50%'} height={25} />
        </h5>
        <h4 className="text-dark fs-5">
          <Skeleton variant="text" width={'70%'} height={25} />
        </h4>
      </div>
    </div>
  );
}
